import Volume from '../../src/legacy/Volume.tsx';
export default Volume;
